import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheServiceService<T> {
  private data:Map<string,CachedItem<T>>
  private ttl:number;
  constructor() { 
    this.data = new Map<string,CachedItem<T>>();
    this.ttl = 60 * 60 * 1000; // 1 hour
  }
  public Get(key:string):Observable<T>{
    let ret = undefined;
    if(this.Exsists(key)){
      const v = this.data.get(key);
      ret = v.payload;
    }
    return of(ret);
  } 
  public Set(key:string, value:T){
    let v = new CachedItem<T>(value);
    this.data.set(key, v);
  }
  public Exsists(key:string):boolean{
    let ret = false;
    if(this.data.has(key)){
      const v = this.data.get(key);
      if(v && !this.exceededTtl(v)){
        ret = true;
      }      
    }
    //console.log('CacheServiceService.Exsists',key, this.data.size, ret);
    return ret;
  }
  private exceededTtl(item: CachedItem<T>):boolean{
    const now = new Date();    
    const age:number = now.getTime() - item.created.getTime();
    return age  > this.ttl;
  }
}


export class CachedItem<T>{
  constructor(item:T){
    this.payload = item;
    this.created = new Date();
  }
  public payload: T;
  public created:Date;
}